var _defs, _path, _path2, _path3, _path4, _path5, _line, _line2, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoodSwingsSliderIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-mood-swings,.cls-2-mood-swings{fill:none;stroke-width:3px;}.cls-1-mood-swings,.cls-2-mood-swings,.cls-3-mood-swings{stroke:#fff;}.cls-1-mood-swings,.cls-3-mood-swings{stroke-miterlimit:10;}.cls-2-mood-swings{stroke-linecap:round;stroke-linejoin:round;}.cls-3-mood-swings,.cls-4-mood-swings{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-mood-swings",
    d: "M20.25,104s-.93-12,0-18,4.85-11.79,9.94-13.41,13-3.93,19.42-3.24l6.48.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-mood-swings",
    d: "M93.14,104s.92-12,0-18S88.28,74.17,83.2,72.55s-13-3.93-19.43-3.24L57.3,70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-mood-swings",
    d: "M60.31,32.35a15.14,15.14,0,0,1-20.18,9.73,31.78,31.78,0,0,0-.23,3.69c0,13.44,8,24.33,17.76,24.33S75.42,59.21,75.42,45.77a32.78,32.78,0,0,0-.74-7,14.56,14.56,0,0,1-1.87.13A15.16,15.16,0,0,1,60.31,32.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-mood-swings",
    d: "M49.61,69.31c-1.24-4.75-22.49-6.21-22.49-11.59,0-23.95,13.51-43.36,30.18-43.36S87.47,33.77,87.47,57.72c0,5.59-19.87,6.56-21.21,11.47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-mood-swings",
    d: "M66.08,71.25c0,5.3-3.93,9.59-8.78,9.59s-8.79-4.29-8.79-9.59"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2-mood-swings",
    x1: 35.74,
    y1: 88.04,
    x2: 35.74,
    y2: 104
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2-mood-swings",
    x1: 77.67,
    y1: 88.04,
    x2: 77.67,
    y2: 104
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-mood-swings",
    d: "M93.52,26.54l.25-.57a5.5,5.5,0,0,1,3.29-2.92c1.55-.6,2.52-1.13,3-2.08a2,2,0,0,0-1-2.9,4.23,4.23,0,0,0-2.48-.5l.22-1.6a6.25,6.25,0,0,1,3.46.8c2.42,1.32,2.7,3.4,1.83,5-.78,1.43-2.14,2-3.8,2.67a4.76,4.76,0,0,0-2.9,2.46l-.24.55Zm-2.06,2.72a1.41,1.41,0,0,1,2-.64,1.5,1.5,0,1,1-2,.64Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-mood-swings",
    d: "M91.89,12.37a3.47,3.47,0,0,0-6.75-.63A3.46,3.46,0,0,0,78.74,14a3.82,3.82,0,0,0,.33,1.12,3.71,3.71,0,0,0,.77,1l.43.34L86.15,21a.17.17,0,0,0,.23,0l4.79-6.06h0a3.43,3.43,0,0,0,.65-1.36A3.62,3.62,0,0,0,91.89,12.37Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-mood-swings",
    d: "M21.14,34a3.46,3.46,0,0,0-5.76,3.56,3.46,3.46,0,0,0-3.78,5.62,3.53,3.53,0,0,0,2.17,1.05,3.25,3.25,0,0,0,.54,0l7.45.12a.17.17,0,0,0,.12,0,.17.17,0,0,0,.05-.12l.17-7.72h0A3.44,3.44,0,0,0,21.8,35,3.57,3.57,0,0,0,21.14,34Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-mood-swings",
    d: "M25.08,29.28a2,2,0,0,1,2.08-2.14,2,2,0,0,1,2,2.14,2,2,0,1,1-4.08,0Zm.87-4.9L25.46,7.76h3.32L28.3,24.38Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-mood-swings",
    d: "M65.9,55.81s-5-.43-8.63,1.22a13.46,13.46,0,0,0-5.52,5.22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodSwingsSliderIcon5);
export default __webpack_public_path__ + "static/media/mood_swings_slider_icon_5.6d4a9c12.svg";
export { ForwardRef as ReactComponent };